import { NavigateURLUtilService } from '../../kymw02/navigate-url/navigate-url-util.service';
import { RegistPlanNumService } from './api-services/regist-plan-num.service';
import { GetResultListService } from './api-services/get-result-list.service';
import { DeleteWorkTableService } from './api-services/delete.work.table.service';
import { MakeResultListService } from './api-services/make.result.list.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { WjCoreModule } from '@grapecity/wijmo.angular2.core';

import { PlessSharedModule } from '../../../shared/pless-shared.module';
import { AppCommonsModule } from '../../../commons/app-commons.module';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { WjChartModule } from '@grapecity/wijmo.angular2.chart';

import { KYMW0800Component } from './kymw0800.component';
import { PdfFileCopyService } from './api-services/pdf-file-copy.service';

/**
 * 実績履歴確認画面 モジュール設定クラス
 *
 * @export KYMW0800Module
 * @class KYMW0800Module
 */
@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    PlessSharedModule,
    AppCommonsModule,
    WjGridModule,
    WjCoreModule,
    WjInputModule,
    WjChartModule,
  ],
  declarations: [
    KYMW0800Component
  ],
  providers: [
    GetResultListService,
    MakeResultListService,
    DeleteWorkTableService,
    RegistPlanNumService,
    PdfFileCopyService,
    NavigateURLUtilService
  ],
})
export class KYMW0800Module {

}
